export const formatBankCard = (cardId?: string) => {
  return cardId?.replace(/(\d{4})(?=\d)/g, '$1 ')
}
